module.exports = __webpack_public_path__ + "static/media/23.c0fa6327.mp4";